<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <!-- <h2 class="brand-text text-primary ml-1">
          Selamat Datang
        </h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-row class="mt-5 mt-lg-0">
          <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto pt-5 pt-lg-0">
            <b-card-title class="mb-1 pt-xs-100">
              Selamat datang di Klinik Patnal
            </b-card-title>
            <b-card-text class="mb-2">
              Di sini, anda dapat melihat mengajukan konsultasi online, pengusulan masalah pada
              Direktorat Jenderal Pemasyarakatan.
            </b-card-text>

            <!-- <b-alert
              variant="primary"
              show
            >
              <div class="alert-body font-small-2">
                <p>
                  <small class="mr-50"><span class="font-weight-bold">Admin:</span> admin | 1234qwer</small>
                </p>
              </div>
              <feather-icon
                v-b-tooltip.hover.left="'This is just for ACL demo purpose'"
                icon="HelpCircleIcon"
                size="18"
                class="position-absolute"
                style="top: 10; right: 10;"
              />
            </b-alert> -->

            <!-- form -->
            <validation-observer ref="loginForm" #default="{invalid}">
              <b-form class="auth-login-form mt-2" @submit.prevent="login">
                <!-- username -->
                <b-form-group label="NIP" label-for="login-username">
                  <validation-provider
                    #default="{ errors }"
                    name="NIP"
                    vid="username"
                    rules="required|digits:18"
                  >
                    <!-- <b-form-input
                      id="login-username"
                      v-model="userName"
                      :state="errors.length > 0 ? false:null"
                      name="login-username"
                      placeholder="NIP"
                      autocomplete="off"
                    /> -->
                    <cleave
                      id="login-username"
                      v-model="userName"
                      name="login-username"
                      :raw="false"
                      class="form-control"
                      :state="errors.length != 18 ? false : null"
                      :options="cleveNumber"
                      autocomplete="off"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Lupa Password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">Password</label>
                    <b-link :to="{ name: 'auth-forgot-password' }">
                      <small>Lupa Password?</small>
                    </b-link>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="Password"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- <vue-recaptcha sitekey="6LehliEnAAAAALJC681nLVc-YTjLKe3Q9dVsZdL_"></vue-recaptcha> -->
                <!-- <VueRecaptcha sitekey="6LehliEnAAAAALJC681nLVc-YTjLKe3Q9dVsZdL_"/> -->
                <!-- <template> -->
                <!-- <VueRecaptcha sitekey="6LehliEnAAAAALJC681nLVc-YTjLKe3Q9dVsZdL_"></VueRecaptcha> -->
                <!-- <vue-recaptcha sitekey="6LehliEnAAAAALJC681nLVc-YTjLKe3Q9dVsZdL_">
                  </vue-recaptcha>
                </template> -->
                <b-form-group>
                  <!-- 6LfnvJQnAAAAAJmGwkNzfaKxlMqR9oKw7i4L_NJv -->
                  <VueRecaptcha
                    @verify="markRecaptchaAsVerified"
                    @expired="onCaptchaExpired"
                    sitekey="6Les8QssAAAAAOpXlHSvvdtFfo_tnuXVl78-nIjw"
                  />
                </b-form-group>
                <!-- checkbox -->
                <!-- <b-form-group>
                  <b-form-checkbox
                    id="remember-me"
                    v-model="status"
                    name="checkbox-1"
                  >
                    Ingat Saya
                  </b-form-checkbox>
                </b-form-group> -->
                <!-- submit buttons -->
                <b-button type="submit" variant="primary" block :disabled="invalid">
                  Sign in
                </b-button>
              </b-form>
            </validation-observer>

            <b-card-text class="text-center mt-2">
              <span>Belum memiliki Akun? </span>
              <b-link :to="{ name: 'auth-register-token' }" v-if="this.applicationToken">
                <span>&nbsp;Daftar Sekarang</span>
              </b-link>
              <b-link :to="{ name: 'auth-register' }" v-else>
                <span>&nbsp;Daftar Sekarang</span>
              </b-link>
            </b-card-text>

            <b-card-text class="text-center mt-2">
              <span>Buku Panduan? </span>
              <b-link @click="downloadGuide">
                <span>&nbsp;Download di sini</span>
              </b-link>
            </b-card-text>

            <!-- <b-card-text class="text-center mt-2">
              <span>Anda Konsultan? </span>
              <b-link :to="{name:'auth-register-konsultan'}">
                <span>&nbsp;Daftar Sekarang</span>
              </b-link>
            </b-card-text> -->

            <!-- divider -->
            <!-- <div class="divider my-2">
              <div class="divider-text">
                or
              </div>
            </div> -->

            <!-- social buttons -->
            <!-- <div class="auth-footer-btn d-flex justify-content-center">
              <b-button
                variant="facebook"
                href="javascript:void(0)"
              >
                <feather-icon icon="FacebookIcon" />
              </b-button>
              <b-button
                variant="twitter"
                href="javascript:void(0)"
              >
                <feather-icon icon="TwitterIcon" />
              </b-button>
              <b-button
                variant="google"
                href="javascript:void(0)"
              >
                <feather-icon icon="MailIcon" />
              </b-button>
              <b-button
                variant="github"
                href="javascript:void(0)"
              >
                <feather-icon icon="GithubIcon" />
              </b-button>
            </div> -->
          </b-col>
        </b-row>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
import {
  Plugins,
  PushNotification,
  PushNotificationToken,
  PushNotificationActionPerformed,
} from '@capacitor/core'
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@/views/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BCardTitle,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
// import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import router from '@/router'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Authlogin, setToken, setRefreshToken } from '@/connection-api/authentication'
// import {VueReCaptcha} from 'vue-recaptcha'
import { VueRecaptcha } from 'vue-recaptcha'
import Cleave from 'vue-cleave-component'

import { getDokumenPanduan } from '@/connection-api/master'

const { PushNotifications } = Plugins

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    VueRecaptcha,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    // BFormCheckbox,
    BCardText,
    BImg,
    BForm,
    BButton,
    BCardTitle,
    // BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    // VueReCaptcha,
    Cleave,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      // sitekey: '6LehliEnAAAAALJC681nLVc-YTjLKe3Q9dVsZdL_',
      status: '',
      password: '',
      userName: '',
      sideImg: require('@/assets/images/pages/login-v2.png'),

      // validation rules
      required,
      email,
      applicationToken: null,
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      cleveNumber: {
        blocks: [18],
        numericOnly: true,
      },
      recaptcha: '',
      ses_recaptcha: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  mounted() {
    this.applicationToken = router.currentRoute.params.token
    const tokenFirebase = localStorage.getItem('tokenFirebase')
    if (tokenFirebase === null) {
      PushNotifications.register()

      PushNotifications.addListener('registration', token => {
        localStorage.setItem('tokenFirebase', token.value)
        // alert(`Push registration success, token: ${token.value}`)
      })

      PushNotifications.addListener('registrationError', error => {
        // alert(`Error on registration: ${JSON.stringify(error)}`)
      })

      PushNotifications.addListener('pushNotificationReceived', notification => {
        // alert(`Push received: ${JSON.stringify(notification)}`)
      })

      PushNotifications.addListener('pushNotificationActionPerformed', notification => {
        // alert(`Push action performed: ${JSON.stringify(notification)}`)
      })
    }
  },
  methods: {
    // markRecaptchaAsVerified(response) {
    //   this.pleaseTickRecaptchaMessage = ''
    //   this.recaptchaVerified = true
    //   alert("aaa")
    //   console.log('aaa')
    //   console.log(response)
    // },
    markRecaptchaAsVerified(recaptchaToken) {
      this.recaptcha = recaptchaToken
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
      this.ses_recaptcha = false
    },

    async downloadGuide() {
      const response = await getDokumenPanduan()
      const blob = new Blob([response.data], { type: response.headers['content-type'] })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'Manual_Book_Asistensi_Online_Divisi-UPT_PAS.pdf' // Nama file yang diunduh
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    onCaptchaExpired() {
      this.recaptcha = ''
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = false
      this.ses_recaptcha = false
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Registrasi',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    login() {
      if (!this.recaptchaVerified) {
        this.pleaseTickRecaptchaMessage = 'Please tick recaptcha.'
        this.makeToast('danger', this.pleaseTickRecaptchaMessage)
      } else {
        this.$refs.loginForm.validate().then(success => {
          if (success) {
            Authlogin({
              nip: this.userName,
              password: this.password,
              application_token: this.applicationToken,
              query: router.currentRoute.query,
              token_firebase: localStorage.getItem('tokenFirebase'),
              recaptcha: this.recaptcha,
              ses_recaptcha: this.ses_recaptcha,
            }).then(response => {
              if (response.data.status.code === '00') {
                if (response.data.error) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Informasi',
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                      text: `${response.data.message}`,
                    },
                  })
                  this.ses_recaptcha = true
                } else {
                  // const { userData } = response.data
                  // alert('masuk sini')
                  const { member, urlCallback } = response.data.data
                  setToken(response.data.data.accessToken)
                  setRefreshToken(response.data.data.refreshToken)

                  /// /////// TEMPORARY ACL SIMULATION ////////////////

                  // baca value userData.roles
                  // value-nya mungkin bisa  array of string atau hanya string
                  // jadi perlu check if array
                  let userRole = ''
                  if (Array.isArray(member.roles)) {
                    // ambil item pertama
                    const test = member.roles[0]
                    userRole = test
                  } else {
                    userRole = member.roles
                  }

                  localStorage.setItem('userData', JSON.stringify(member))
                  this.$ability.update(member.ability)
                  if (urlCallback === '') {
                    this.$router.push('/').then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Selamat Datang ${member.fullName || member.username}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text:
                            'Anda telah berhasil masuk Klinik Patnal Online. Sekarang Anda bisa mulai menjelajah!',
                        },
                      })
                    })
                  } else {
                    localStorage.setItem('urlCallback', urlCallback)
                    window.location.href = urlCallback
                  }
                }
              } else {
                this.makeToast('danger', response.data.data)
              }
            })
          }
        })
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
